<script lang="ts" setup>
import AdvancedSearchIcon from '~/assets/icon/general/AdvancedSearch.svg'
const searchValue = ref('')
const searchInputContainer = ref(null)

const localePath = useLocalePath()
const props = defineProps({
  hideAdvancedSearch: {
    type: Boolean,
    required: false,
    default: false,
  },
  sidney: {
    type: Boolean,
    required: false,
    default: false,
  },
  inHome: {
    type: Boolean,
    required: false,
    default: false,
  },
})

function getSearchValue(v: string) {
  searchValue.value = v
}
const route = useRoute()
const router = useRouter()

const goToAdvancedSearch = () => {
  navigateTo(localePath(`/advanced_search`))
}
const submitForm = async () => {
  await router.push({
    path: localePath('/search_result'),
    query: {
      search: searchValue.value,
      ...(props.sidney
        ? {
            collection: 'work_versions',
          }
        : {}),
    },
  })
}
</script>
<template>
  <form @keyup.enter="submitForm" @submit.stop.prevent="submitForm">
    <div>
      <SearchInput
        :inHome="inHome"
        :sidney="sidney"
        ref="searchInputContainer"
        v-model="searchValue"
        :placeholder="$t('labels.search')"
        :autocomplete="true"
        @search="getSearchValue"
        v-if="!route.query?.print"
      />
    </div>
    <p
      v-if="!hideAdvancedSearch"
      @click="goToAdvancedSearch"
      class="flex bg-primary-400 cursor-pointer p-4 mt-8 text-white font-bold text-md w-fit gap-2 items-center transition-colors duration-200 ease-in-out hover:bg-shade-900 focus:ring focus:ring-primary-alpha-400 focus-visible:outline-none"
    >
      <span class="first-letter:uppercase">{{
        $t('labels.advanced_search')
      }}</span>
      <AdvancedSearchIcon />
    </p>
  </form>
</template>
